import { MEMBER_SETTINGS_PAGE } from '../../ids';
import { InstallLocation } from '../../types';
export const ids = MEMBER_SETTINGS_PAGE;
export const getDefinition = (staticsUrl, t) => ({
    ...ids,
    installLocation: InstallLocation.Standalone,
    method: 'addSection',
    page: {
        name: t('member-pages.settings-page.name'),
        shortDescription: t('member-pages.settings-page.subtitle'),
        description: '',
        iconURL: `${staticsUrl}assets/images/icons/members-area-icon.svg`,
        origin: '',
        screenshots: [],
    },
});
//# sourceMappingURL=member-settings-page.js.map